var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIdCard = function SvgIdCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0C0E11",
    clipPath: "url(#idCard_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.69 5.6c2.04 0 3.71 1.66 3.71 3.71v5.26c0 2.04-1.66 3.71-3.71 3.71H7.31c-2.04 0-3.71-1.66-3.71-3.71V9.31c0-2.04 1.66-3.71 3.71-3.71zm0-1.6H7.31C4.38 4 2 6.38 2 9.31v5.26c0 2.93 2.38 5.31 5.31 5.31h9.38c2.93 0 5.31-2.38 5.31-5.31V9.31C22 6.38 19.62 4 16.69 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 11.45a1.47 1.47 0 1 0 0-2.94 1.47 1.47 0 0 0 0 2.94M8.57 11.85H7.01c-1.28 0-2.32 1.05-2.32 2.32v.75c0 .25.2.45.45.45h5.3c.25 0 .45-.2.45-.45v-.75c0-1.28-1.05-2.32-2.32-2.32M18.52 9.59h-5.56c-.44 0-.8.36-.8.8s.36.8.8.8h5.56c.44 0 .8-.36.8-.8s-.36-.8-.8-.8M16.29 12.69h-3.38c-.44 0-.8.36-.8.8s.36.8.8.8h3.38c.44 0 .8-.36.8-.8s-.36-.8-.8-.8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "idCard_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIdCard;